export const getCategoryAndBrandsApiEndpoint = (baseSiteId,isMastOrder) =>
    `/occ/v2/${baseSiteId}/products/productBrandAndCategoryList?isMastOrder=${isMastOrder}`;

export const getProductsByBrandOrSuperCategoryApiEndpoint = (queryParams) =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productDetailsByFacetCategoryBrand?${queryParams}`;

export const getValidatedProductsEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/validateproduct?${queryParams}`;

export const getPricesForItemsEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/price?${queryParams}`;
